import {getCorrelationId} from '../lib/UserSession';
import {LOG_LEVEL} from './logger-levels';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export default class logger {
  constructor(options, appInsightId) {
    this.options = options;
    this.appInsights = new ApplicationInsights(
      { 
        config: {
          instrumentationKey: appInsightId
        } 
      });
      this.appInsights.loadAppInsights();    
  }

  debug(message, obj) {
    this.log(LOG_LEVEL.DEBUG, message, obj);
   }

  info(message, obj) {
    this.log(LOG_LEVEL.INFO, message, obj);
  }

  warning(message, err) {
    this.log(LOG_LEVEL.WARNING, message, err);
  }

  error(message, err) {
    this.log(LOG_LEVEL.ERROR, message, err);
  }

  fatal(message, err) {
    this.log(LOG_LEVEL.FATAL, message, err);
  }

  log(level, message, data) {
     
    let d = new Date();
    let isoDate = d.toISOString();

    // Log to CONSOLE
    try {
      // try to get the session ID:
      let sessionId = getCorrelationId();
      if (
        this.options.logToConsole !== LOG_LEVEL.OFF &&
        level >= this.options.logToConsole
      ) {
        this.logToConsole(level, message, data, sessionId, isoDate);
      }
    } catch {
      //nothing, if we can't log then we can't do much else.
    }

    // Log to remote SERVER
    try {
      // try to get the session ID:
      let sessionId = getCorrelationId();
      if (
        this.options.logToServer !== LOG_LEVEL.OFF &&
        level >= this.options.logToServer
      ) {
        this.logToServer(level, message, data, sessionId, isoDate);
      }
    } catch {
      //nothing, if we can't log then we can't do much else.
    }
  }

  logToServer(level, message, data, sessionId, isoDate) {
    try {
      let formattedMessage = isoDate + ' | UI Server | ' + this.getLevelForServerLogging(level) + ' | ' + message;
      if (sessionId) {
        formattedMessage += ` | sessionId: ${JSON.stringify(sessionId)}`;
      }
      if (data) {
        formattedMessage += ` | data: ${JSON.stringify(data)}`;
      }
      // Log to AppInsight
      this.appInsights.trackException({exception: new Error(formattedMessage)});

    } catch (ex) {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
    }
  }

  logToConsole(level, message, data, sessionId, isoDate) {
    let formattedMessage = isoDate + ' | UI Server | ' + this.getLevelForServerLogging(level) + ' | '  + message;
    if (sessionId) {
      formattedMessage += ` | sessionId: ${JSON.stringify(sessionId)}`;
    }
    if (data) {
      formattedMessage += ` | data: ${JSON.stringify(data)}`;
    }

    switch (level) {
      case LOG_LEVEL.ERROR:
      case LOG_LEVEL.FATAL:
        if (console.error) {
            console.error(formattedMessage);
        } else {
          console.log(formattedMessage);
        }
        break;
      case LOG_LEVEL.WARNING:
        if (console.warn) {
            console.warn(formattedMessage);
        } else {
            console.log(formattedMessage);
        }
        break;
      default:
          console.log(formattedMessage);
        break;
    }
  }

  getLevelForServerLogging(level){
    switch (level) {
      case LOG_LEVEL.ERROR:
        return 'ERROR';
      case LOG_LEVEL.FATAL:
        return 'FATAL';
      case LOG_LEVEL.WARNING:
        return 'WARNING';
      case LOG_LEVEL.DEBUG:
        return 'DEBUG';
      case LOG_LEVEL.INFO:
        return 'INFO';
      default:
        return '';
    }
  }
}
